<script setup>
import Sidebar from '@/components/layouts/Sidebar.vue';
import ClientOnboardingOverlayNew from '@/components/modals/ClientOnboardingOverlayNew.vue';
import {getLoggedUser, refreshLoggedUser} from '@/services/AuthService';
import {ref} from 'vue';
import AnimatedRouterView from '@/components/layouts/AnimatedRouterView.vue';
import {getAppDomain} from '@/helper';

const showOnboardingOverlay = ref(false);
const assistedOnboarding = ref(null);
const loggedUser = ref(null);

// IMA-511: přesné znění schválené byznysem, liší se podle brandu appky (ne podle jazykové
// mutace cs/sk) - proto mimo i18n soubory, stejně jako brand kontakty v TenantService.js.
const READ_ONLY_BANNER_TEXT = {
  'CZ': 'Tento účet je aktuálně ve stavu {status}. Pro více informací kontaktujte náš back office na e-mailu backoffice@in-equity.cz nebo na nahrávané telefonní lince +420 558 274 590.',
  'SK': 'Tento účet je aktuálne v stave {status}. Pre viac informácií kontaktujte náš back office na e-maile backoffice@biginvest.sk alebo na nahrávanej telefónnej linke +421 463 127 000.',
  'SK/CZ': 'Tento účet je aktuálně ve stavu {status}. Pro více informací kontaktujte náš back office na e-mailu backoffice@biginvest.cz nebo na nahrávané telefonní lince +420 558 274 245.',
};

function readOnlyBannerText() {
  const template = READ_ONLY_BANNER_TEXT[getAppDomain()] ?? READ_ONLY_BANNER_TEXT['CZ'];
  return template.replace('{status}', loggedUser.value?.client?.account_status_label ?? '');
}

getLoggedUser()
    .then((user) => {
      loggedUser.value = user;
      // IMA-511: read-only klienta nesmíme nutit do onboarding wizardu, který stejně nemůže
      // dokončit (backend by odeslání kroku zamítl 403) - jen by ho to uvěznilo v appce.
      if (user?.meta?.waiting_interaction_forms > 0 && !user?.client?.is_read_only) {
        showOnboardingOverlay.value = true;
      }
    })

emitter.on('onboardingDone', () => {
  showOnboardingOverlay.value = false;
  void refreshLoggedUser();
});

emitter.on('startAssistedOnboarding', (value) => {
  assistedOnboarding.value = value;
  showOnboardingOverlay.value = true;
});

</script>

<template>
  <Sidebar/>
  <div class="main-container">
    <!-- IMA-511: read-only banner pro klienta ve stavu Inheritance_process/Inheritance_closed/Invalid.
         Mezera pod bannerem (mb-4) je na něm samotném, takže se projeví jen když se banner zobrazuje. -->
    <div v-if="loggedUser?.role === 'CLIENT' && loggedUser?.client?.is_read_only" class="alert alert-warning read-only-banner mb-4 rounded-0">
      {{ readOnlyBannerText() }}
    </div>
    <ClientOnboardingOverlayNew v-if="showOnboardingOverlay" :assistedOnboarding="assistedOnboarding"></ClientOnboardingOverlayNew>
    <template v-if="!showOnboardingOverlay">
      <AnimatedRouterView> </AnimatedRouterView>
    </template>
  </div>
</template>
